export class CatalogAccessResponse {
    'statusCode';
    'body';
    'error';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "statusCode",
            "baseName": "statusCode",
            "type": "number",
            "format": ""
        },
        {
            "name": "body",
            "baseName": "body",
            "type": "any",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CatalogAccessResponse.attributeTypeMap;
    }
    constructor() {
    }
}
